import {
  applyStoredConsent,
  grantAnalyticsConsent,
  denyAnalyticsConsent,
  dismissAnalyticsNotice,
  onConsentChange,
  hasAnalyticsConsent,
  loadFontAwesome,
} from './consent';
import { initGtag, trackEvent, trackPageView } from './gtag';
import { initSessionTracker } from './sessionTracker';
import { initClickTracker } from './clickTracker';
import { EVENTS } from './events';

export { trackEvent, trackPageView } from './gtag';
export { setPendingEntryMethod, notifySectionChange, getSessionState } from './sessionTracker';
export {
  grantAnalyticsConsent,
  denyAnalyticsConsent,
  dismissAnalyticsNotice,
  shouldShowAnalyticsNotice,
  shouldShowConsentBanner,
  onConsentChange,
  hasAnalyticsConsent,
  getStoredConsent,
} from './consent';
export { EVENTS } from './events';
export { GA4_CONVERSION_SETUP } from './goals';

let teardownSessionTracker = null;
let teardownClickTracker = null;

function startTrackers() {
  if (!teardownSessionTracker) {
    teardownSessionTracker = initSessionTracker();
  }
  if (!teardownClickTracker) {
    teardownClickTracker = initClickTracker();
  }
}

function stopTrackers() {
  if (teardownSessionTracker) {
    teardownSessionTracker();
    teardownSessionTracker = null;
  }
  if (teardownClickTracker) {
    teardownClickTracker();
    teardownClickTracker = null;
  }
}

export function setupAnalytics() {
  loadFontAwesome();
  applyStoredConsent();

  if (hasAnalyticsConsent()) {
    initGtag();
    startTrackers();
    trackPageView();
  }

  const unsubscribe = onConsentChange((choice) => {
    if (choice === 'granted') {
      initGtag();
      startTrackers();
      trackPageView();
      return;
    }

    stopTrackers();
  });

  return () => {
    unsubscribe();
    stopTrackers();
  };
}

export function optOutAnalytics() {
  trackEvent(EVENTS.CONSENT_CHOICE, { choice: 'opt_out' });
  denyAnalyticsConsent();
  dismissAnalyticsNotice();
}

export function optInAnalytics() {
  grantAnalyticsConsent();
  trackEvent(EVENTS.CONSENT_CHOICE, { choice: 'opt_in' });
}

export function dismissAnalyticsNoticeOnly() {
  dismissAnalyticsNotice();
  trackEvent(EVENTS.CONSENT_CHOICE, { choice: 'notice_dismissed' });
}
